import { createSlice } from "@reduxjs/toolkit";
import { dashboardApi } from "../services/dashboardApi";

const initialState = {
  allCategories: null,
  allContinueBatches: null,
  allRecommended: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        dashboardApi.endpoints.getAllCategories.matchFulfilled,
        (state, { payload }) => {
          state.allCategories = payload.data;
        }
      )
      .addMatcher(
        dashboardApi.endpoints.getAllCategories.matchRejected,
        (state, { payload }) => {
          state.allCategories = null;
        }
      )
      .addMatcher(
        dashboardApi.endpoints.getAllContinueBatches.matchFulfilled,
        (state, { payload }) => {
          state.allContinueBatches = payload.data;
        }
      )
      .addMatcher(
        dashboardApi.endpoints.getAllContinueBatches.matchRejected,
        (state, { payload }) => {
          state.allContinueBatches = null;
        }
      )
      .addMatcher(
        dashboardApi.endpoints.getRecommendedTraining.matchFulfilled,
        (state, { payload }) => {
          state.allRecommended = payload.data;
        }
      )
      .addMatcher(
        dashboardApi.endpoints.getRecommendedTraining.matchRejected,
        (state, { payload }) => {
          state.allRecommended = null;
        }
      );
  },
});

export const {} = dashboardSlice.actions;

export default dashboardSlice.reducer;
